export default "__VITE_ASSET__Bwpz6gpr__"